/**
 * Wrapper for autosearch, used on GAYL site for store search box in header
 * 
 * A history of search terms is saved in Local Storage and shown in an auto-complete list when the searchbox is first opened
 */

 'use strict';

const buildIcon = require("Scripts/common/build-icon");
const AutoSearch = require("Scripts/common/autosearch.js");

module.exports = Searchbox;

const STORAGE_KEY = 'gayl-searchbox-stores';

function Searchbox(form) {
	this.init = function() {
		this.form  = form || $("#js-nav-search");

		if(this.form.length) {
			const options = {
				form: this.form,
				history: true,
				parent: this,
				url: options => `/merchant/autocomplete?q=${encodeURIComponent(options.input.val())}&rows=${options.form.data('rows') || 5}`,
				html: data => {
					const clearIcon = data.value.date ? ` <span role="button" class="searchbox-clear" title="Remove" data-id="${data.value.id}">` + buildIcon("fa-circle-xmark") + `</span>` : '';
					return `<a href="${data.value.pagePath}">${data.match.name}${clearIcon}</a>`
				},
				onSelect: data => {
					// So that the clear icon works, we have to check what's being clicked
					const tag = data.event.target.tagName;
					if(tag == "A" || tag == "INPUT") {
						window.open(data.selection.value.pagePath, "_self");
					}
				}
			}

			const search = new AutoSearch(options);

			this.addHistory();
		}
	}

	this.addHistory = function() {
		try {
			const data = this.getHistoryData();
			if(!data.id) return;

			console.log("Searchbox.addHistory()", data.id);

			const list = this.getHistoryList(data.id);
			list.unshift(data);
			this.updateHistory(list);
		} catch(err) {
			return [];
		}
	}

	this.getHistoryData = function() {
		const data = $("#js-search-history").data();
		if(!data) return false;
		return data;
	}

	this.updateHistory = function(list) {
		list = JSON.stringify(list.slice(0,9));
		localStorage.setItem(STORAGE_KEY, list);
	}

	this.getHistoryList = function(id) {
		try {
			console.log("Searchbox.getHistoryList()", id);

			const localStorageList = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

			if(localStorageList.length) {
				return localStorageList.filter(item => this.normaliseId(item.id) != this.normaliseId(id) && !item.name.includes('escapedQuery'));
			}
		} catch(err) { 
			/* Nothing */ 
		}

		return [];
	}

	this.clearHistoryId = function(id) {
		console.log("Searchbox.clearHistoryId()", id)
		const list = this.getHistoryList().filter(item => this.normaliseId(item.id) != this.normaliseId(id));
		this.updateHistory(list);
	}

	// ID can be a number or a string, and we want it to be case-insensitive
	this.normaliseId = function(id) {
		return id?.toString()?.toLowerCase();
	}

	this.init();
}